import React from 'react';
import bgImg from '../assets/bg.png';
import logo from '../assets/logo.png';
const ContactPage = () => {
  return (
    <>
      <section className=' text-gray-600 body-font relative bg-[#af6ed4]'>
        <img
          src={bgImg}
          alt=''
          className='absolute inset-0 w-full h-full object-cover filter blur-sm'
        />
        <div className='container mx-auto py-24  grid  md:grid-cols-2'>
          <div className='mb-10 md:mb-0 w-full  bg-gray-300 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative'>
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2815.673469295068!2d90.39081297708657!3d23.92096976450604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c4932189b2bd%3A0xf52d91cf2b6544dd!2sGazipura%20Bus%20Stop!5e0!3m2!1sen!2sbd!4v1685600018341!5m2!1sen!2sbd'
              width='100%'
              height='100%'
              className='absolute inset-0'
              frameBorder={0}
              title='map'
              marginHeight={0}
              marginWidth={0}
              scrolling='no'
            />
            <div className='bg-white relative flex flex-wrap py-6 rounded shadow-md'>
              <div className='lg:w-1/2 px-6'>
                <h2 className='title-font font-semibold text-gray-900 tracking-widest text-xs'>
                  ADDRESS
                </h2>
                <p className='mt-1'>
                  Tongi,Gazipur,Dhaka, <br /> Bangladesh
                </p>
              </div>
              <div className='lg:w-1/2 px-6 mt-4 lg:mt-0'>
                <h2 className='title-font font-semibold text-gray-900 tracking-widest text-xs'>
                  EMAIL
                </h2>
                <a className='text-indigo-500 leading-relaxed'>
                  emrosesajib@email.com
                </a>
                <h2 className='title-font font-semibold text-gray-900 tracking-widest text-xs mt-4'>
                  PHONE
                </h2>
                <p className='leading-relaxed'>0167-976-2206</p>
              </div>
            </div>
          </div>
          <div className='w-4/5	 px-10 bg-black py-16 mx-auto rounded-md '>
            <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
              <img
                className='mx-auto h-10 w-auto bg-black  '
                src={logo}
                alt='Your Company'
              />
              <h2 className='my-5  text-center text-2xl font-bold leading-9 tracking-tight text-white'>
                Contact with us
              </h2>
            </div>

            <div className='mt-10 sm:mx-auto sm:w-full sm:max-w-sm'>
              <form
                className='space-y-6 text-white'
                // action='#'
                // onSubmit={handleSubmit(onSubmit)}
              >
                <div>
                  <label
                    htmlFor='userName'
                    className='block text-sm font-medium leading-6 text-white text-start'
                  >
                    Name
                  </label>
                  <div className='mt-2'>
                    <input
                      style={{ fontSize: '14px' }}
                      type='text'
                      placeholder='Username'
                      // {...register('username')}
                      className=' form-control block w-full p-5 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
                    />
                  </div>
                </div>

                <div>
                  <div className='flex items-center justify-between'>
                    <label
                      htmlFor='email'
                      className='block text-sm font-medium leading-6 text-white'
                    >
                      Email
                    </label>
                  </div>
                  <div className='mt-2'>
                    <input
                      style={{ fontSize: '14px' }}
                      type='email'
                      placeholder='Enter your email'
                      // {...register('password')}
                      className='form-control block w-full p-5 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor='email'
                    className='block text-sm font-medium leading-6 text-white text-start'
                  >
                    Message
                  </label>
                  <div className='mt-2'>
                    <textarea
                      style={{ fontSize: '14px', height: '120px' }}
                      type='text'
                      placeholder='message'
                      // {...register('username')}
                      className='form-control block w-full p-5 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
                    />
                  </div>
                </div>

                <div>
                  <button
                    type='submit'
                    className='flex rounded-md px-8 py-1  text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 bg-purple-600'
                  >
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
